import { PageInfo } from '../../share-types'

export enum CampaignPopupStatusEnums {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  INTERNAL_ONLY = 'INTERNAL_ONLY',
}

export enum CampaignPopupUserTypeEnums {
  ALL_USER = 'ALL_USER',
  NEW_USER = 'NEW_USER',
  OLD_USER = 'OLD_USER',
  CORPORATE_USER = 'CORPORATE_USER',
}

export enum CampaignPopupRedirectTypeEnums {
  DEEP_LINK = 'DEEP_LINK',
  EXTERNAL = 'EXTERNAL',
}

export type CampaignPopup = {
  id: number
  summary: string
  imageUrl: string
  startDate: string
  endDate: string
  redirectUrl: string
  redirectType: string
  userType: string
  status: string
}

export type PaginatedCampaignPopup = {
  pageInfo: PageInfo
  data: CampaignPopup[]
}

export interface CreateCampaignPopupParams {
  summary: string
  imageUrl: string
  startDate: any
  endDate: any
  redirectUrl: string
  redirectType: CampaignPopupRedirectTypeEnums
  userType: CampaignPopupUserTypeEnums
  status: CampaignPopupStatusEnums
}

export interface CampaignPopupFormData {
  summary: string
  imageUrl: any
  rangeTime: string[]
  redirectUrl: string
  redirectType: CampaignPopupRedirectTypeEnums
  userType: CampaignPopupUserTypeEnums
  status: CampaignPopupStatusEnums
}

export type ICampaignPopupFilterParams = {
  summary?: string
  startDate?: string
  endDate?: string
  userType?: CampaignPopupUserTypeEnums
  status?: CampaignPopupStatusEnums
}

export type IPaginatedCampaignPopupFilterParams = {
  page?: number
  size?: number
} & ICampaignPopupFilterParams
